export default __webpack_public_path__ + "static/media/anita_elias.9efad234.jpg";